<template>
  <div>
    <!-- 新增/编辑的对话框 -->
    <el-dialog
      :title="title"
      :visible="visible"
      width="40%"
      :modal-append-to-body="false"
      append-to-body
      @close="handleClose"
    >
      <el-collapse>
        <el-collapse-item>
          <template slot="title">
            <div class="title-blue">
              商品基础配置&nbsp;<i class="header-icon el-icon-info"></i>
            </div>
          </template>
          <div class="bg-gray">
            <!-- 商品基础配置表单 -->
            <el-form
              :model="baseForm"
              ref="baseForm"
              :rules="baseFormRules"
              :disabled="optionType !== 'add'"
              label-width="100px"
              class="baseForm"
            >
              <el-form-item prop="goodsCode" label="商品编号">
                <el-input
                  v-model="baseForm.goodsCode"
                  clearable
                  maxlength="99"
                  size="small"
                  placeholder="请输入商品编号"
                ></el-input>
              </el-form-item>
              <el-form-item prop="goodsName" label="商品名称">
                <el-input
                  v-model="baseForm.goodsName"
                  clearable
                  maxlength="99"
                  size="small"
                  placeholder="请输入商品名称"
                ></el-input>
              </el-form-item>
              <el-form-item prop="partnerId" label="联运方">
                <el-select
                  v-model="baseForm.partnerId"
                  clearable
                  size="small"
                  placeholder="请选择联运方"
                >
                  <el-option
                    v-for="item in initData.partnerList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="partnerProductId" label="联运产品ID">
                <el-input
                  v-model="baseForm.partnerProductId"
                  clearable
                  maxlength="99"
                  size="small"
                  placeholder="请输入联运产品ID"
                ></el-input>
              </el-form-item>
              <el-form-item prop="partnerGoodsId" label="联运商品ID">
                <el-input
                  v-model="baseForm.partnerGoodsId"
                  clearable
                  maxlength="99"
                  size="small"
                  placeholder="请输入联运商品ID"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-item>
        <el-collapse-item>
          <template slot="title">
            <div class="title-blue">
              商品展示配置&nbsp;<i class="header-icon el-icon-info"></i>
            </div>
          </template>
          <!-- 商品展示配置表单 -->
          <el-form
            :model="showForm"
            ref="showForm"
            :rules="showFormFormRules"
            label-width="120px"
            class="showForm"
            :validate-on-rule-change="false"
          >
            <div class="bg-gray">
              <!-- 关联乐播会员 -->
              <!--     - 点击输入框，显示“级联”选择，可多选 
              - 第一级为当前的会员类型  
                  - 第二级为当前的会员类型下的所有会员商品
                - 过滤：商品类型需为“线上商品”
                - 商品名称+商品编号
                - 选择对应的商品时，下方显示蓝色区块（可操作删除）-->
              <el-form-item prop="leboMemberGoodsIds" label="关联乐播会员">
                <el-cascader
                  :options="initData.memberGoods"
                  :props="{ multiple: true }"
                  collapse-tags
                  clearable
                  size="small"
                  separator="-"
                  ref="memberCascader"
                  v-model="showForm.leboMemberGoodsIds"
                  @change="uniteMemberChange"
                ></el-cascader>
              </el-form-item>
              <el-form-item>
                <el-tag
                  :key="item.id"
                  v-for="item in memberGoodsTag"
                  closable
                  :disable-transitions="false"
                  @close="tagsClosed(item)"
                  style="margin-right: 5px"
                >
                  {{ item.label }}
                </el-tag>
              </el-form-item>
              <!-- 销售端类型 -->
              <el-form-item label="销售端类型" prop="saleChannelList">
                <el-button size="small" @click="addSaleItem"
                  >添加销售端</el-button
                >
              </el-form-item>
              <div
                class="saleType-flex"
                v-for="(item, index) in showForm.saleChannelList"
                :key="item"
              >
                <div class="flex">
                  <el-form-item
                    class="saleType-class"
                    :prop="`saleChannelList.${index}.clientType`"
                  >
                    <el-select
                      v-model="item.clientType"
                      clearable
                      size="small"
                      placeholder="选择销售端类型"
                      style="width: 150px; margin-right: 10px"
                    >
                      <el-option
                        v-for="item in initData.saleType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        :disabled="item.disabled"
                      ></el-option>
                    </el-select>
                    <el-form-item
                      :prop="`saleChannelList.${index}.channelType`"
                    >
                      <el-select
                        v-model="item.channelType"
                        clearable
                        size="small"
                        placeholder="请选择渠道类型"
                        @change="channelTypeChange($event, item)"
                        style="width: 150px; margin-right: 10px"
                      >
                        <el-option
                          v-for="item in initData.channelType"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-button
                      type="text"
                      icon="el-icon-delete"
                      style="color: #ff0000"
                      @click="
                        showForm.saleChannelList =
                          showForm.saleChannelList.filter((i) => i !== item)
                      "
                      >删除</el-button
                    >
                  </el-form-item>
                </div>
                <div>
                  <el-form-item
                    v-if="item.channelType !== 1 && item.channelType !== ''"
                    label="指定渠道"
                    :prop="`saleChannelList.${index}.channelIds`"
                  >
                    <el-input
                      type="textarea"
                      @focus="channelInputClick(item)"
                      v-model="item.channelNames"
                    >
                    </el-input>
                    <channel-popups
                      :isAppendToBody="true"
                      :modelIsAppendToBody="false"
                      :app-id="item.channelIds"
                      :visible.sync="item.channelVisible"
                      @comfirm="channelConfirm($event, item)"
                      :multiple="true"
                    ></channel-popups>
                  </el-form-item>
                </div>
              </div>
              <!-- - 前端可见    - 必选，默认选择是，单选-->
              <el-form-item label="前端可见" prop="frontVisible">
                <el-radio-group v-model="showForm.frontVisible">
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <!-- - 显示顺序   - 输入框，正整数，字符限制9999 -->
              <el-form-item label="显示顺序" prop="displayOrder">
                <el-input
                  v-model="showForm.displayOrder"
                  clearable
                  maxlength="9999"
                  size="small"
                  placeholder="请输入显示顺序,从1开始"
                ></el-input>
              </el-form-item>
              <!-- - 定价周期 -->
              <el-form-item label="定价周期" prop="salePeriod">
                <el-input
                  :disabled="optionType !== 'add'"
                  v-model="showForm.salePeriod"
                  clearable
                  maxlength="99"
                  size="small"
                  placeholder="请输入数字"
                ></el-input>
              </el-form-item>
              <el-form-item prop="salePeriodUnit">
                <!-- 定价周期单位:1-日,2-月,3-季,4-年 -->
                <el-select
                  :disabled="optionType !== 'add'"
                  v-model="showForm.salePeriodUnit"
                  clearable
                  size="small"
                  placeholder="请选择定价周期单位"
                >
                  <el-option label="日" :value="1"></el-option>
                  <el-option label="月" :value="2"></el-option>
                  <el-option label="季" :value="3"></el-option>
                  <el-option label="年" :value="4"></el-option>
                </el-select>
              </el-form-item>
              <!-- 售价 必填，输入框，正整数，字符限制99-->
              <el-form-item label="售价" prop="salePrice">
                <div style="display: flex">
                  <el-input
                    :disabled="optionType !== 'add'"
                    style="width: 250px !important"
                    v-model="showForm.salePrice"
                    clearable
                    maxlength="99"
                    size="small"
                    placeholder="输入金额"
                  ></el-input>
                  &nbsp;元
                </div>
              </el-form-item>
              <!-- - 限制购买次数 必选、单选，默认选择不限制 0-不限制,1-1次-->
              <el-form-item label="限制购买次数" prop="limitPurchaseTimesFlag">
                <el-radio-group v-model="showForm.limitPurchaseTimesFlag">
                  <el-radio :label="0">不限制</el-radio>
                  <el-radio :label="1">1次</el-radio>
                </el-radio-group>
              </el-form-item>
              <!-- - Icon  非必填-->
              <el-form-item label="Icon" prop="goodsIcon">
                <div class="flex">
                  <el-image
                    v-if="showForm.goodsIcon"
                    style="width: 100px; margin-right: 10px"
                    :src="showForm.goodsIcon"
                    fit="scale-down"
                  ></el-image>
                  <el-upload
                    :before-upload="checkUpload"
                    :http-request="upload"
                    listType="picture-img"
                    :show-file-list="false"
                  >
                    <el-button size="small" type="primary">上传图片</el-button>
                  </el-upload>
                </div>
              </el-form-item>
              <!-- 短描述   - 选填，输入框，9999字符限制-->
              <el-form-item label="短描述" prop="shortDescription">
                <el-input
                  v-model="showForm.shortDescription"
                  clearable
                  maxlength="9999"
                  size="small"
                  placeholder="请输入短描述"
                ></el-input>
              </el-form-item>
              <!-- 备注 -->
              <el-form-item label="备注" prop="remark">
                <el-input
                  type="textarea"
                  show-limit-word
                  v-model="showForm.remark"
                  clearable
                  maxlength="99999"
                  size="small"
                  placeholder="请输入备注"
                ></el-input>
              </el-form-item>
            </div>
            <!-- 商品状态   - 必选，生效、失效-->
            <el-form-item label="商品状态" prop="state">
              <el-radio-group v-model="showForm.state">
                <el-radio :label="1">生效</el-radio>
                <el-radio :label="0">失效</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </el-collapse-item>
      </el-collapse>
      <!-- 取消跟保存按钮 -->
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">取消</el-button>
        <el-button size="small" type="primary" @click="handleSave"
          >保存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getUnite,
  getMemberType,
  getClientTypes,
  getChannelTypes,
  getMemberGoods,
  addUnite,
  editUnite,
} from "@/api/memberNew/memberUnite";
import ChannelPopups from "@/components/channel-popups";
import axios from "axios";
import Message from "@/components/Message";
import {
  uniteMemberGoodsFormat,
  uniteMemberGoodsFormatForUpload,
} from "../helper/index";
import { cloneDeep } from "lodash";
export default {
  name: "WebSaaSAdd",
  components: {
    ChannelPopups,
  },
  inject: ["getList"],
  computed: {
    /** 对话框标题 */
    title() {
      return this.optionType === "add" ? "新增联运商品" : "编辑联运商品";
    },
    /** 商品展示表单规则 */
    showFormFormRules() {
      let rules = {
        leboMemberGoodsIds: [
          {
            required: true,
            type: "array",
            message: "请选择关联乐播会员",
            trigger: "change",
          },
        ],

        frontVisible: [
          { required: true, message: "请选择前端可见", trigger: "change" },
        ],
        displayOrder: [
          { required: true, message: "请输入显示顺序", trigger: "blur" },
          // 正整数
          {
            required: true,
            pattern: /^[1-9]\d*$/,
            message: "请输入正整数",
            trigger: "blur",
          },
        ],
        salePeriod: [
          // 正整数
          {
            required: true,
            pattern: /^[1-9]\d*$/,
            message: "请输入正整数",
            trigger: "blur",
          },
          { required: true, message: "请输入定价周期", trigger: "blur" },
        ],
        salePeriodUnit: [
          { required: true, message: "请选择定价周期单位", trigger: "change" },
        ],
        salePrice: [
          // 最多两位小数

          {
            required: true,
            pattern: /^\d+(\.\d{1,2})?$/,
            message: "请输入最多两位小数",
            trigger: "blur",
          },
          { required: true, message: "请输入售价", trigger: "blur" },
        ],
        limitPurchaseTimesFlag: [
          { required: true, message: "请选择限制购买次数", trigger: "change" },
        ],
        goodsIcon: [
          { required: false, message: "请上传Icon", trigger: "blur" },
        ],
        shortDescription: [
          { required: true, message: "请输入短描述", trigger: "blur" },
        ],
        remark: [{ required: true, message: "请输入备注", trigger: "blur" }],
        state: [
          { required: true, message: "请选择商品状态", trigger: "change" },
        ],
      };
      rules.saleChannelList = {
        required: true,
        // type: "array",
        validator: (rule, value, callback) => {
          if (value.length === 0) {
            callback(new Error("请选择销售端类型"));
          } else {
            callback();
          }
        },
        trigger: "change",
      };
      if (this.showForm.saleChannelList.length) {
        this.showForm.saleChannelList.forEach((item, index) => {
          rules.saleChannelList[index] = {
            clientType: [
              {
                required: true,
                message: "请选择销售端类型",
                trigger: ["change", "blur"],
              },
            ],
            channelType: [
              {
                required: true,
                message: "请选择渠道类型",
                trigger: ["change", "blur"],
              },
            ],
            channelIds: [
              {
                required: true,
                message: "请选择指定渠道",
                trigger: ["change", "blur"],
              },
            ],
          };
        });
      }

      console.log("rules", rules);
      return rules;
    },
  },
  data() {
    return {
      /** 对话框显隐 */
      visible: false,
      /** 操作类型 */
      optionType: "add",
      /** 商品基础表单 */
      baseForm: {
        /** 商品编号 */
        goodsCode: "",
        /** 商品名称 */
        goodsName: "",
        /** 联运方 */
        partnerId: "",
        /** 联运产品ID */
        partnerProductId: "",
        /** 联运商品ID */
        partnerGoodsId: "",
      },
      /** 商品基础表单验证规则 */
      baseFormRules: {
        goodsCode: [
          { required: true, message: "请输入商品编号", trigger: "blur" },
        ],
        goodsName: [
          { required: true, message: "请输入商品名称", trigger: "blur" },
        ],
        partnerId: [
          { required: true, message: "请选择联运方", trigger: "change" },
        ],
        partnerProductId: [
          { required: true, message: "请输入联运产品ID", trigger: "blur" },
        ],
        partnerGoodsId: [
          { required: true, message: "请输入联运商品ID", trigger: "blur" },
        ],
      },
      /** 展示商品表单 */
      showForm: {
        /** 关联乐播会员 */
        leboMemberGoodsIds: [],
        /** 销售端类型 */
        saleChannelList: [],
        /** 前端可见 */
        frontVisible: true,
        /** 显示顺序 */
        displayOrder: "",
        /** 定价周期 */
        salePeriod: "",
        /** 定价周期单位 */
        salePeriodUnit: "",
        /** 售价 */
        salePrice: "",
        /** 限制购买次数 */
        limitPurchaseTimesFlag: 0,
        /** Icon */
        goodsIcon: "",
        /** 短描述 */
        shortDescription: "",
        /** 备注 */
        remark: "",
        /** 商品状态 */
        state: "",
      },
      /** 会员商品级联选择器 */
      memberGoodsCascade: [],
      /** 会员商品标签 */
      memberGoodsTag: [],
      /** 初始化的数据 */
      initData: {
        /** 联运方 */
        partnerList: [],
        /** 关联乐播会员商品 */
        memberGoods: [],
        /** 销售端类型 */
        saleType: [],
        /** 会员商品map */
        memberGoodsMap: {},
      },
    };
  },
  created() {
    this.getPartnerList();
    this.getMemberType();
    this.getClientTypes();
    this.getChannelTypes();
    this.getMemberGoods();
  },
  watch: {
    "showForm.uniteMember.length"(val) {
      console.log("级联变化", val);
    },
  },
  methods: {
    /** 上传图片校验 */
    checkUpload(file) {
      // 判断类型
      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        Message.error("目前只支持jpg/png图片");
        return false;
      }
      // 判断大小
      if (file.size > 1024 * 1024 * 5) {
        Message.error("不能上传超过5M的图片");
        return false;
      }
    },
    /** 上传图片的方法 */
    async upload(params) {
      const file = params.file;
      let formData = new FormData();
      formData.append("file", file);
      try {
        const { data } = await axios.post(
          "/lebo-resource/oss/endpoint/put-file?code=lebotob",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        console.log("上传图片的响应", data);
        const result = data.data;
        if (data.code === 200) {
          /** 上传成功 */
          /** 赋值 */
          this.showForm.goodsIcon = result.link;
          /** 提示用户 */
          Message.success("上传成功");
        }
      } catch (error) {
        throw new Error(error);
      }
    },
    /** 点击渠道选择框 */
    channelInputClick(item) {
      console.log("点击渠道选择框", item);
      item.channelVisible = true;
    },
    /** 渠道类型改变 */
    channelTypeChange(val, item) {
      console.log("渠道类型改变", val, item);
    },
    /** 确认渠道选择 */
    channelConfirm($event, item) {
      console.log("渠道选择的数据", $event, item);
      const { appId, nameStr } = $event;
      item.channelIds = appId;
      item.channelNames = nameStr;
    },
    /** 添加销售端 */
    addSaleItem() {
      console.log("添加销售端");
      /** 已经有的销售端禁止选择 */
      const clientTypeArr = this.showForm.saleChannelList.map(
        (item) => item.clientType
      );
      console.log("已经有的销售端禁止选择", clientTypeArr);
      this.initData.saleType.forEach((item) => {
        if (clientTypeArr.includes(item.value)) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
      });
      this.showForm.saleChannelList.push({
        clientType: "",
        channelType: "",
        channelIds: "",
        channelNames: "",
        /** 渠道选择框的显隐 */
        channelVisible: false,
      });
    },
    /** 移除乐播会员商品 */
    tagsClosed(item) {
      console.log("移除乐播会员商品", item);
      this.showForm.leboMemberGoodsIds =
        this.showForm.leboMemberGoodsIds.filter((i) => i[1] !== item.value);
      /** 自身也要删除 */
      this.memberGoodsTag = this.memberGoodsTag.filter(
        (i) => i.value !== item.value
      );
    },
    /** 关联乐播会员级联选择事件 */
    uniteMemberChange(val) {
      console.log("关联乐播会员级联选择事件", val);
      this.memberGoodsTag = val.map((item) => {
        return {
          label: this.initData.memberGoodsMap.get(item[1]),
          value: item[1],
        };
      });
    },
    /** 表单规则验证 */
    validateForm() {
      return new Promise((resolve, reject) => {
        this.$refs.baseForm.validate((valid) => {
          if (valid) {
            console.log("基础表单验证通过");
            this.$refs.showForm.validate((valid) => {
              if (valid) {
                resolve();
              } else {
                reject(new Error("展示表单验证不通过"));
              }
            });
          } else {
            reject(new Error("基础表单验证不通过"));
          }
        });
      });
    },
    //^ ^-------------对话框自身相关-------------^ ^
    /** 保存 */
    async handleSave() {
      const res = await this.validateForm();
      console.log("验证通过", res);
      // 两个表单验证都通过后的处理逻辑
      console.log("保存", this.baseForm);
      const deepShowForm = cloneDeep(
        uniteMemberGoodsFormatForUpload(this.showForm)
      );
      console.log("保存", deepShowForm);
      /** 新增/编辑联运商品接口 */
      const params = {
        ...this.baseForm,
        ...deepShowForm,
      };
      try {
        if (this.optionType === "edit") {
          console.log("编辑联运商品接口的参数", params);
          const { data } = await editUnite(params);
          console.log("编辑联运商品接口的响应", data);
          if (data && data.code === 200) {
            Message.success("编辑成功");
            this.getList();
          }
          this.hide();
        } else {
          console.log("新增联运商品接口的参数", params);
          const { data } = await addUnite(params);
          console.log("新增联运商品接口的响应", data);
          if (data && data.code === 200) {
            Message.success("新增成功");
            this.getList();
            this.hide();
          }
        }
      } catch (error) {
        this.hide();
        console.log("新增/编辑联运商品接口的错误", error);
      }
    },
    show(row, optionType) {
      console.log("新增/编辑的对话框", row, optionType);
      if (row) {
        this.baseForm = row.baseForm;
        this.showForm = row.showForm;
        /** 只有编辑的时候 才有code */
        if (optionType === "edit") {
          /** 修改memberGoodsMap里面的label */
          this.showForm.leboMemberGoodsIds.forEach((item, index) => {
            const oriLabel = this.initData.memberGoodsMap.get(item[1]);
            this.initData.memberGoodsMap.set(
              item[1],
              `${oriLabel} (${row.showForm.saleGoodsIds[index]})`
            );
            // item[0] = this.initData.memberGoodsMap.get(item[1]);
          });
        }
        /** 商品标签 */
        this.memberGoodsTag = row.showForm.leboMemberGoodsIds.map((item) => {
          return {
            label: this.initData.memberGoodsMap.get(item[1]),
            value: item[1],
          };
        });
      }
      this.optionType = optionType || "add";
      this.visible = true;
    },
    hide() {
      this.visible = false;
    },
    /** 关闭对话框 */
    handleClose() {
      this.visible = false;
      /** 清除商品基础表单验证规则 */
      this.$refs.baseForm.resetFields();
      /** 清除展示商品表单验证规则 */
      this.showForm = {
        /** 关联乐播会员 */
        leboMemberGoodsIds: [],
        /** 销售端类型 */
        saleChannelList: [],
        /** 前端可见 */
        frontVisible: true,
        /** 显示顺序 */
        displayOrder: "",
        /** 定价周期 */
        salePeriod: "",
        /** 定价周期单位 */
        salePeriodUnit: "",
        /** 售价 */
        salePrice: "",
        /** 限制购买次数 */
        limitPurchaseTimesFlag: 0,
        /** Icon */
        goodsIcon: "",
        /** 短描述 */
        shortDescription: "",
        /** 备注 */
        remark: "",
        /** 商品状态 */
        state: "",
      };
      this.$refs.showForm.clearValidate();
      /** 关闭了商品标签也要清空 */
      this.memberGoodsTag = [];
      /** 重置initData里面的goodsMap */
      this.getMemberGoods();
    },
    //^ ^--------------初始化数据-------------^ ^
    /** 获取以会员类型分组所有的会员商品 */
    async getMemberGoods() {
      const { data } = await getMemberGoods();
      console.log("获取以会员类型分组所有的会员商品接口的响应", data);
      this.initData.memberGoods = uniteMemberGoodsFormat(data.data);
      console.log("this.initData.memberGoods", this.initData.memberGoods);
      /** 会员商品map */
      this.initData.memberGoodsMap = new Map();
      this.initData.memberGoods.forEach((item) => {
        item.children.forEach((i) => {
          this.initData.memberGoodsMap.set(i.value, i.label);
        });
      });
    },
    /** 获取联运方 */
    async getPartnerList() {
      const { data } = await getUnite();
      console.log("获取业务字典联运方接口的响应", data);
      this.initData.partnerList = data.data.map((item) => {
        return {
          label: item.dictValue,
          value: item.dictKey,
        };
      });
    },
    /** 获取会员类别 */
    async getMemberType() {
      const { data } = await getMemberType();
      console.log("获取业务字典会员类别接口的响应", data);
      this.initData.goodsCascade = data.data.map((item) => {
        return {
          label: item.dictValue,
          value: item.dictKey,
          children: [
            {
              label: "普通会员",
              value: "1",
            },
            {
              label: "VIP会员",
              value: "2",
            },
            {
              label: "SVIP会员",
              value: "3",
            },
          ],
        };
      });
    },
    /** 获取客户端类型 */
    async getClientTypes() {
      const { data } = await getClientTypes();
      console.log("获取业务字典客户端类型接口的响应", data);
      this.initData.saleType = data.data.map((item) => {
        return {
          label: item.dictValue,
          value: item.dictKey,
        };
      });
    },
    /** 获取渠道类型 */
    async getChannelTypes() {
      const { data } = await getChannelTypes();
      console.log("获取业务字典渠道类型接口的响应", data);
      this.initData.channelType = data.data.map((item) => {
        return {
          label: item.dictValue,
          value: Number(item.dictKey),
        };
      });
    },
  },
};
</script>
<!--  -->
<style lang="scss" scoped>
.flex {
  display: flex;
  align-items: center;
}
.title-blue {
  position: relative;
  margin-left: 5px;
  /** 伪元素 */
  &:before {
    position: absolute;
    content: "";
    display: inline-block;
    width: 3px;
    height: 14px;
    background-color: #409eff;
    top: 17px;
    left: -5px;
  }
}
.bg-gray {
  background-color: #f5f7fa;
  padding: 10px;
  ::v-deep .el-input {
    width: auto;
  }
}
.baseForm {
  ::v-deep .el-input__inner {
    width: 250px !important;
  }
}

.saleType-flex {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
.saleType-class {
  ::v-deep .el-form-item__content {
    display: flex;
  }
}
</style>